/* tslint:disable */
/* eslint-disable */
/**
 * ClinicManagement API
 * This is an OpenAPI for the Clinic Management Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddEmployeeRequest } from '../models';
import { AddEmployeeResponse } from '../models';
import { AddUserEmployeeRequest } from '../models';
import { AddUserEmployeeResponse } from '../models';
import { ApproveEmployeeRequest } from '../models';
import { ApproveEmployeeResponse } from '../models';
import { ChangePasswordRequest } from '../models';
import { ChangePasswordResponse } from '../models';
import { DeleteEmployeeResponse } from '../models';
import { EditEmployeeRequest } from '../models';
import { EditEmployeeResponse } from '../models';
import { EditUserEmployeeRequest } from '../models';
import { EditUserEmployeeResponse } from '../models';
import { Employee } from '../models';
import { EmployeeBranchAccessResponse } from '../models';
import { GetEmployeeResponse } from '../models';
import { InlineResponse200 } from '../models';
import { ObjectID } from '../models';
import { SignUpEmployeeRequest } from '../models';
import { SignUpEmployeeResponse } from '../models';
/**
 * EmployeeApi - axios parameter creator
 * @export
 */
export const EmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This Api allows authorized employees to add a user to the platform and make him Employee in the tenant in a specific branch
         * @summary Add User to platform and Employee to Tenant.
         * @param {AddUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployeeAndUser: async (body?: AddUserEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee/NewUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds Employee to branch in tenant, can be called by high Auth employees.
         * @summary Add Employee to Tenant
         * @param {AddEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployeetoTenant: async (body?: AddEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This api can be called by high auth employees to approve/ reject a user's employee sign up request
         * @summary Approves Employee to Tenant
         * @param {ApproveEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveEmployeetoTenant: async (body?: ApproveEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee/SignUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An Api to change User password
         * @summary Change User Password
         * @param {ChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (body?: ChangePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows employees to delete their profile, and can also be called by high auth employees
         * @summary Delete Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenantEmployee: async (employeeID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeID' is not null or undefined
            if (employeeID === null || employeeID === undefined) {
                throw new RequiredError('employeeID','Required parameter employeeID was null or undefined when calling deleteTenantEmployee.');
            }
            const localVarPath = `/Employee/{EmployeeID}`
                .replace(`{${"EmployeeID"}}`, encodeURIComponent(String(employeeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows employees to edit their profile, and can also be called by high auth employees
         * @summary Edit Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {EditEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTenantEmployee: async (employeeID: string, body?: EditEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeID' is not null or undefined
            if (employeeID === null || employeeID === undefined) {
                throw new RequiredError('employeeID','Required parameter employeeID was null or undefined when calling editTenantEmployee.');
            }
            const localVarPath = `/Employee/{EmployeeID}`
                .replace(`{${"EmployeeID"}}`, encodeURIComponent(String(employeeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows employees to edit their profile and user info, and can also be called by high auth employees
         * @summary Edit Tenant Employee and User
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {string} userID id value that needs to be considered for filter
         * @param {EditUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTenantEmployeeAndUser: async (employeeID: string, userID: string, body?: EditUserEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeID' is not null or undefined
            if (employeeID === null || employeeID === undefined) {
                throw new RequiredError('employeeID','Required parameter employeeID was null or undefined when calling editTenantEmployeeAndUser.');
            }
            // verify required parameter 'userID' is not null or undefined
            if (userID === null || userID === undefined) {
                throw new RequiredError('userID','Required parameter userID was null or undefined when calling editTenantEmployeeAndUser.');
            }
            const localVarPath = `/Employee/{UserID}/{EmployeeID}`
                .replace(`{${"EmployeeID"}}`, encodeURIComponent(String(employeeID)))
                .replace(`{${"UserID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An Api that give an employee access to other branches
         * @summary Give Employees Access to other branches
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeBranchAccess: async (userID: string, branchID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            if (userID === null || userID === undefined) {
                throw new RequiredError('userID','Required parameter userID was null or undefined when calling employeeBranchAccess.');
            }
            // verify required parameter 'branchID' is not null or undefined
            if (branchID === null || branchID === undefined) {
                throw new RequiredError('branchID','Required parameter branchID was null or undefined when calling employeeBranchAccess.');
            }
            const localVarPath = `/Employee/AccessBranch/{UserID}/{BranchID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(userID)))
                .replace(`{${"BranchID"}}`, encodeURIComponent(String(branchID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }            

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This api can be called by super admin to view all employee signups
         * @summary Gets all Employee Signups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSignups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee/SignUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all  Employees , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets all Employees, can be filtered by Tenant And/OR Branch And/OR Role
         * @param {ObjectID} [branchID] 
         * @param {ObjectID} [tenantID] 
         * @param {ObjectID} [roleID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesofTenant: async (branchID?: ObjectID, tenantID?: ObjectID, roleID?: ObjectID, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            if (branchID !== undefined) {
                localVarQueryParameter['BranchID'] = branchID;
            }

            if (tenantID !== undefined) {
                localVarQueryParameter['TenantID'] = tenantID;
            }

            if (roleID !== undefined) {
                localVarQueryParameter['RoleID'] = roleID;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a Tenant branch Employee by ID , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets Tenant Employee by ID
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantEmployeeById: async (employeeID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeID' is not null or undefined
            if (employeeID === null || employeeID === undefined) {
                throw new RequiredError('employeeID','Required parameter employeeID was null or undefined when calling getTenantEmployeeById.');
            }
            const localVarPath = `/Employee/{EmployeeID}`
                .replace(`{${"EmployeeID"}}`, encodeURIComponent(String(employeeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows owner and admin to delete/remove employee from a specific branch
         * @summary Remove Employee from Branch
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployeeFromBranch: async (userID: string, branchID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            if (userID === null || userID === undefined) {
                throw new RequiredError('userID','Required parameter userID was null or undefined when calling removeEmployeeFromBranch.');
            }
            // verify required parameter 'branchID' is not null or undefined
            if (branchID === null || branchID === undefined) {
                throw new RequiredError('branchID','Required parameter branchID was null or undefined when calling removeEmployeeFromBranch.');
            }
            const localVarPath = `/Employee/AccessBranch/{UserID}/{BranchID}`
                .replace(`{${"UserID"}}`, encodeURIComponent(String(userID)))
                .replace(`{${"BranchID"}}`, encodeURIComponent(String(branchID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * An Api for users to sign up as a employee to a certain branch in a tenant.
         * @summary Sign Up Employee to Tenant
         * @param {SignUpEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpEmployeetoTenant: async (body?: SignUpEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Employee/Signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeApi - functional programming interface
 * @export
 */
export const EmployeeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This Api allows authorized employees to add a user to the platform and make him Employee in the tenant in a specific branch
         * @summary Add User to platform and Employee to Tenant.
         * @param {AddUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployeeAndUser(body?: AddUserEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AddUserEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).addEmployeeAndUser(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds Employee to branch in tenant, can be called by high Auth employees.
         * @summary Add Employee to Tenant
         * @param {AddEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployeetoTenant(body?: AddEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AddEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).addEmployeetoTenant(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This api can be called by high auth employees to approve/ reject a user's employee sign up request
         * @summary Approves Employee to Tenant
         * @param {ApproveEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveEmployeetoTenant(body?: ApproveEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ApproveEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).approveEmployeetoTenant(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An Api to change User password
         * @summary Change User Password
         * @param {ChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(body?: ChangePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ChangePasswordResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).changePassword(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Allows employees to delete their profile, and can also be called by high auth employees
         * @summary Delete Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTenantEmployee(employeeID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).deleteTenantEmployee(employeeID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Allows employees to edit their profile, and can also be called by high auth employees
         * @summary Edit Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {EditEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTenantEmployee(employeeID: string, body?: EditEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EditEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).editTenantEmployee(employeeID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Allows employees to edit their profile and user info, and can also be called by high auth employees
         * @summary Edit Tenant Employee and User
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {string} userID id value that needs to be considered for filter
         * @param {EditUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTenantEmployeeAndUser(employeeID: string, userID: string, body?: EditUserEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EditUserEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).editTenantEmployeeAndUser(employeeID, userID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An Api that give an employee access to other branches
         * @summary Give Employees Access to other branches
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeBranchAccess(userID: string, branchID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EmployeeBranchAccessResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).employeeBranchAccess(userID, branchID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This api can be called by super admin to view all employee signups
         * @summary Gets all Employee Signups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSignups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<InlineResponse200>>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).getEmployeeSignups(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all  Employees , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets all Employees, can be filtered by Tenant And/OR Branch And/OR Role
         * @param {ObjectID} [branchID] 
         * @param {ObjectID} [tenantID] 
         * @param {ObjectID} [roleID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesofTenant(branchID?: ObjectID, tenantID?: ObjectID, roleID?: ObjectID, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<Employee>>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).getEmployeesofTenant(branchID, tenantID, roleID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets a Tenant branch Employee by ID , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets Tenant Employee by ID
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantEmployeeById(employeeID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).getTenantEmployeeById(employeeID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Allows owner and admin to delete/remove employee from a specific branch
         * @summary Remove Employee from Branch
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmployeeFromBranch(userID: string, branchID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).removeEmployeeFromBranch(userID, branchID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * An Api for users to sign up as a employee to a certain branch in a tenant.
         * @summary Sign Up Employee to Tenant
         * @param {SignUpEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpEmployeetoTenant(body?: SignUpEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SignUpEmployeeResponse>>> {
            const localVarAxiosArgs = await EmployeeApiAxiosParamCreator(configuration).signUpEmployeetoTenant(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmployeeApi - factory interface
 * @export
 */
export const EmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This Api allows authorized employees to add a user to the platform and make him Employee in the tenant in a specific branch
         * @summary Add User to platform and Employee to Tenant.
         * @param {AddUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployeeAndUser(body?: AddUserEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<AddUserEmployeeResponse>> {
            return EmployeeApiFp(configuration).addEmployeeAndUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds Employee to branch in tenant, can be called by high Auth employees.
         * @summary Add Employee to Tenant
         * @param {AddEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployeetoTenant(body?: AddEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<AddEmployeeResponse>> {
            return EmployeeApiFp(configuration).addEmployeetoTenant(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This api can be called by high auth employees to approve/ reject a user's employee sign up request
         * @summary Approves Employee to Tenant
         * @param {ApproveEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveEmployeetoTenant(body?: ApproveEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<ApproveEmployeeResponse>> {
            return EmployeeApiFp(configuration).approveEmployeetoTenant(body, options).then((request) => request(axios, basePath));
        },
        /**
         * An Api to change User password
         * @summary Change User Password
         * @param {ChangePasswordRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(body?: ChangePasswordRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<ChangePasswordResponse>> {
            return EmployeeApiFp(configuration).changePassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows employees to delete their profile, and can also be called by high auth employees
         * @summary Delete Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTenantEmployee(employeeID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteEmployeeResponse>> {
            return EmployeeApiFp(configuration).deleteTenantEmployee(employeeID, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows employees to edit their profile, and can also be called by high auth employees
         * @summary Edit Tenant Employee
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {EditEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTenantEmployee(employeeID: string, body?: EditEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<EditEmployeeResponse>> {
            return EmployeeApiFp(configuration).editTenantEmployee(employeeID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows employees to edit their profile and user info, and can also be called by high auth employees
         * @summary Edit Tenant Employee and User
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {string} userID id value that needs to be considered for filter
         * @param {EditUserEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTenantEmployeeAndUser(employeeID: string, userID: string, body?: EditUserEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<EditUserEmployeeResponse>> {
            return EmployeeApiFp(configuration).editTenantEmployeeAndUser(employeeID, userID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * An Api that give an employee access to other branches
         * @summary Give Employees Access to other branches
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeBranchAccess(userID: string, branchID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<EmployeeBranchAccessResponse>> {
            return EmployeeApiFp(configuration).employeeBranchAccess(userID, branchID, options).then((request) => request(axios, basePath));
        },
        /**
         * This api can be called by super admin to view all employee signups
         * @summary Gets all Employee Signups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSignups(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<InlineResponse200>>> {
            return EmployeeApiFp(configuration).getEmployeeSignups(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all  Employees , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets all Employees, can be filtered by Tenant And/OR Branch And/OR Role
         * @param {ObjectID} [branchID] 
         * @param {ObjectID} [tenantID] 
         * @param {ObjectID} [roleID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesofTenant(branchID?: ObjectID, tenantID?: ObjectID, roleID?: ObjectID, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<Employee>>> {
            return EmployeeApiFp(configuration).getEmployeesofTenant(branchID, tenantID, roleID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a Tenant branch Employee by ID , can be called by doctors and employees, maybe by patients later on in v2
         * @summary Gets Tenant Employee by ID
         * @param {string} employeeID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantEmployeeById(employeeID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetEmployeeResponse>> {
            return EmployeeApiFp(configuration).getTenantEmployeeById(employeeID, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows owner and admin to delete/remove employee from a specific branch
         * @summary Remove Employee from Branch
         * @param {string} userID id value that needs to be considered for filter
         * @param {string} branchID id value that needs to be considered for filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmployeeFromBranch(userID: string, branchID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteEmployeeResponse>> {
            return EmployeeApiFp(configuration).removeEmployeeFromBranch(userID, branchID, options).then((request) => request(axios, basePath));
        },
        /**
         * An Api for users to sign up as a employee to a certain branch in a tenant.
         * @summary Sign Up Employee to Tenant
         * @param {SignUpEmployeeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpEmployeetoTenant(body?: SignUpEmployeeRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<SignUpEmployeeResponse>> {
            return EmployeeApiFp(configuration).signUpEmployeetoTenant(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeApi - object-oriented interface
 * @export
 * @class EmployeeApi
 * @extends {BaseAPI}
 */
export class EmployeeApi extends BaseAPI {
    /**
     * This Api allows authorized employees to add a user to the platform and make him Employee in the tenant in a specific branch
     * @summary Add User to platform and Employee to Tenant.
     * @param {AddUserEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async addEmployeeAndUser(body?: AddUserEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<AddUserEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).addEmployeeAndUser(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adds Employee to branch in tenant, can be called by high Auth employees.
     * @summary Add Employee to Tenant
     * @param {AddEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async addEmployeetoTenant(body?: AddEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<AddEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).addEmployeetoTenant(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This api can be called by high auth employees to approve/ reject a user's employee sign up request
     * @summary Approves Employee to Tenant
     * @param {ApproveEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async approveEmployeetoTenant(body?: ApproveEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<ApproveEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).approveEmployeetoTenant(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An Api to change User password
     * @summary Change User Password
     * @param {ChangePasswordRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async changePassword(body?: ChangePasswordRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<ChangePasswordResponse>> {
        return EmployeeApiFp(this.configuration).changePassword(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Allows employees to delete their profile, and can also be called by high auth employees
     * @summary Delete Tenant Employee
     * @param {string} employeeID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async deleteTenantEmployee(employeeID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).deleteTenantEmployee(employeeID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Allows employees to edit their profile, and can also be called by high auth employees
     * @summary Edit Tenant Employee
     * @param {string} employeeID id value that needs to be considered for filter
     * @param {EditEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async editTenantEmployee(employeeID: string, body?: EditEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<EditEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).editTenantEmployee(employeeID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Allows employees to edit their profile and user info, and can also be called by high auth employees
     * @summary Edit Tenant Employee and User
     * @param {string} employeeID id value that needs to be considered for filter
     * @param {string} userID id value that needs to be considered for filter
     * @param {EditUserEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async editTenantEmployeeAndUser(employeeID: string, userID: string, body?: EditUserEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<EditUserEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).editTenantEmployeeAndUser(employeeID, userID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An Api that give an employee access to other branches
     * @summary Give Employees Access to other branches
     * @param {string} userID id value that needs to be considered for filter
     * @param {string} branchID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async employeeBranchAccess(userID: string, branchID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<EmployeeBranchAccessResponse>> {
        return EmployeeApiFp(this.configuration).employeeBranchAccess(userID, branchID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This api can be called by super admin to view all employee signups
     * @summary Gets all Employee Signups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async getEmployeeSignups(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<InlineResponse200>>> {
        return EmployeeApiFp(this.configuration).getEmployeeSignups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all  Employees , can be called by doctors and employees, maybe by patients later on in v2
     * @summary Gets all Employees, can be filtered by Tenant And/OR Branch And/OR Role
     * @param {ObjectID} [branchID] 
     * @param {ObjectID} [tenantID] 
     * @param {ObjectID} [roleID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async getEmployeesofTenant(branchID?: ObjectID, tenantID?: ObjectID, roleID?: ObjectID, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<Employee>>> {
        return EmployeeApiFp(this.configuration).getEmployeesofTenant(branchID, tenantID, roleID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a Tenant branch Employee by ID , can be called by doctors and employees, maybe by patients later on in v2
     * @summary Gets Tenant Employee by ID
     * @param {string} employeeID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async getTenantEmployeeById(employeeID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).getTenantEmployeeById(employeeID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Allows owner and admin to delete/remove employee from a specific branch
     * @summary Remove Employee from Branch
     * @param {string} userID id value that needs to be considered for filter
     * @param {string} branchID id value that needs to be considered for filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async removeEmployeeFromBranch(userID: string, branchID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).removeEmployeeFromBranch(userID, branchID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * An Api for users to sign up as a employee to a certain branch in a tenant.
     * @summary Sign Up Employee to Tenant
     * @param {SignUpEmployeeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public async signUpEmployeetoTenant(body?: SignUpEmployeeRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<SignUpEmployeeResponse>> {
        return EmployeeApiFp(this.configuration).signUpEmployeetoTenant(body, options).then((request) => request(this.axios, this.basePath));
    }
}